import { AdTrackingContext } from '@/contexts/adTrackingContext'
import {
  Box,
  Button,
  Center,
  Heading,
  Text
} from '@chakra-ui/react'
import { Player } from '@lottiefiles/react-lottie-player'
import { useAuthStore } from '@olagg/store'
import { useContext, useEffect } from 'react'
import { analytics } from '../../../analytics'
import { IMultiStageModalContent } from '../../../interfaces/IMultiStageModalContent'

interface IProps {
  onClose: () => void
  currentStep: string
  gameId: string
  inputs: object
  applicationId: number
  credentialsId: string
}

export const Success = ({
  onClose,
  currentStep,
  gameId,
  applicationId,
  credentialsId,
  inputs
}: IProps): IMultiStageModalContent => {
  const { me } = useAuthStore()
  const { fcb, fbp } = useContext(AdTrackingContext)

  useEffect(() => {
    ; (async () => {
      if (currentStep === 'success') {
        let props = {
          game_id: gameId,
          user_id: me.id,
          inputs,
          application_id: applicationId,
          credentials_id: credentialsId,
          user_agent: navigator.userAgent
        }
        if (fcb != null) props.fbc = fcb
        if (fbp != null) props.fbp = fbp
        analytics()?.track('Scholarship User Data updated', props)
      }
    })()
  }, [currentStep])

  return {
    body: (
      <>
        <Center>
          <Box w={{ base: '90%', lg: '65%' }}>
            <Player
              autoplay
              loop
              src="/animations/in-construction/in-construction.json"
            />
          </Box>
        </Center>
        <Heading
          fontSize={'24px'}
          color={'olaggPurple.100'}
          pb={4}
          mt={5}
        >
          ¡Estamos creando tu cuenta!
        </Heading>
        <Text
          fontSize={'16px'}
          lineHeight={'24px'}
          fontFamily={'text'}
        >
          Gracias por completar tus datos. En breve tu beca
          estará disponible.
        </Text>
      </>
    ),
    footer: (
      <Box px={1} w={'full'}>
        <Button
          variant={'filledGradient'}
          w={'full'}
          onClick={onClose}
        >
          Regresar
        </Button>
      </Box>
    )
  }
}
